import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/ui";
import type { StripeBillingPortalButtonBlock as StripeBillingPortalButtonBlockType } from "../../../../shared/schema";
import { useStripeBillingPortalButton } from "./useStripeBillingPortalButton";

interface StripeBillingPortalButtonBlockProps {
  block: StripeBillingPortalButtonBlockType;
}

export const StripeBillingPortalButtonBlock = ({ block }: StripeBillingPortalButtonBlockProps) => {
  const { t } = useTranslation(["payments", "common"]);
  const { isVisible, isLoading, error, handleClick } = useStripeBillingPortalButton();

  if (!isVisible) return null;

  return (
    <div>
      <Button variant={block.props.variant} disabled={isLoading} onClick={handleClick}>
        {isLoading ? t("Loading...", { ns: "common" }) : block.props.label}
      </Button>
      {error && <p className="mt-2 text-sm text-destructive">{error}</p>}
    </div>
  );
};
